import { z } from 'zod';
/**
 * Роли участника воркспейса, от большего к меньшему.
 * operator работает с диалогами и заказами, но не видит учётных данных —
 * это требование зафиксировано в архитектуре и проверяется тестом.
 */
export const MEMBERSHIP_ROLES = ['owner', 'admin', 'operator', 'viewer'];
export const membershipRoleSchema = z.enum(MEMBERSHIP_ROLES);
/** Чем выше число, тем больше прав. Для сравнений вида `rank(role) >= rank('admin')`. */
const RANK = {
    viewer: 0,
    operator: 1,
    admin: 2,
    owner: 3,
};
export function roleRank(role) {
    return RANK[role];
}
export function roleAtLeast(role, required) {
    return roleRank(role) >= roleRank(required);
}
/** Роли, которым разрешено видеть и менять учётные данные интеграций. */
export function canManageCredentials(role) {
    return roleAtLeast(role, 'admin');
}
//# sourceMappingURL=roles.js.map